import Vue from 'vue'
import MemberService from '@/assets/services/MemberService'
import PlaylistService from '@/assets/services/PlaylistService'

const AUTH_ACCESS_TOKEN_KEY = process.env.VUE_APP_AUTH_ACCESS_TOKEN_KEY

const USER_CLEAR = 'USER_CLEAR'
const USER_REQUEST = 'USER_REQUEST'
const USER_REQUEST_SUCCESS = 'USER_REQUEST_SUCCESS'
const USER_REQUEST_ERROR = 'USER_REQUEST_ERROR'

const UPDATE_USER_PLAYLIST = 'UPDATE_USER_PLAYLIST'
const UPDATE_USER_FOLLOWING = 'UPDATE_USER_FOLLOWING'

const AUTH_REQUEST_SUCCESS = 'AUTH_REQUEST_SUCCESS'
const AUTH_REQUEST_ERROR = 'AUTH_REQUEST_ERROR'
const AUTH_LOGOUT = 'AUTH_LOGOUT'

const state = {
  profile: {},
  status: '',
  following: undefined,
  playlist: undefined
}
const getters = {
  isAuthenticated: state => state.profile.id,
  getProfile: state => state.profile,
  getProfileStatus: state => state.status,
  getUserFollowing: state => state.following,
  getUserPlaylist: state => state.playlist
}
const mutations = {
  [USER_CLEAR]: state => {
    state.profile = {}
    state.following = undefined
    state.playlist = undefined
  },
  [USER_REQUEST]: state => {
    state.status = 'pending'
    state.profile = {}
  },
  [USER_REQUEST_SUCCESS]: (state, data) => {
    state.status = 'success'
    Vue.set(state, 'profile', data)
  },
  [USER_REQUEST_ERROR]: state => {
    state.status = 'error'
    Vue.set(state, 'profile', {})
  },
  [UPDATE_USER_PLAYLIST]: (state, data) => {
    state.playlist = data
  },
  [UPDATE_USER_FOLLOWING]: (state, data) => {
    state.following = data
  }
}
const actions = {
  [USER_REQUEST]: async ({ commit, dispatch }, token) => {
    commit(USER_REQUEST)
    const member = await MemberService.getMe(token)
    if (member) {
      window.localStorage.setItem(AUTH_ACCESS_TOKEN_KEY, token)
      commit(AUTH_REQUEST_SUCCESS, token)
      commit(USER_REQUEST_SUCCESS, member)
      const gParams = {
        data: { 'user_id': member.id }
      }
      dispatch('GTAG_CONFIG', gParams) // SET GA USER ID

      return member
    } else {
      commit(AUTH_REQUEST_ERROR)
      commit(USER_REQUEST_ERROR)
      dispatch(AUTH_LOGOUT)
      return null
    }
  },
  [UPDATE_USER_PLAYLIST]: async ({ state, commit, dispatch }) => {
    const params = {
      'q': {
        'user_id': state.profile.id
      }
    }
    const playlistResponse = await PlaylistService.getPlaylists(params)
    if (playlistResponse) {
      commit(UPDATE_USER_PLAYLIST, playlistResponse.data)
    } else {
      commit(UPDATE_USER_PLAYLIST, [])
    }
  },
  [UPDATE_USER_FOLLOWING]: async ({ state, commit, dispatch }) => {
    const followingListResponse = await PlaylistService.getPlaylistFollowing(state.profile.id)
    if (followingListResponse) {
      commit(UPDATE_USER_FOLLOWING, followingListResponse.data)
    } else {
      commit(UPDATE_USER_FOLLOWING, [])
    }
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
